module.exports = __webpack_public_path__ + "assets/img/refresh.0f0e763d.svg";